import { Injectable, signal } from '@angular/core';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { map } from 'rxjs/operators';
import { BehaviorSubject, filter } from 'rxjs';
import { IBreadcrumbItem } from '../../shared/components/breadcrumbs/typings/bread-brumb-item';

const breadcrumbDataKey = 'breadcrumb';

@Injectable({
    providedIn: 'root',
})
export class BreadcrumbService {
    private readonly _breadcrumbs = new BehaviorSubject<IBreadcrumbItem[]>([]);
    public readonly breadcrumbs$ = this._breadcrumbs.asObservable();

    constructor(
        private readonly activatedRoute: ActivatedRoute,
        private readonly router: Router,
    ) {
    }

    // ----------[ API ]----------

    public init() {
        this.router.events.pipe(
            filter(event => event instanceof NavigationEnd),
            map(() => this.activatedRoute),
            map(route => this.calculateBreadcrumbs(route)),
        ).subscribe(breadcrumbs => {
            this.setBreadcrumbs(breadcrumbs);
        });
    }

    // ----------[ Methods ]----------

    private calculateBreadcrumbs(route: ActivatedRoute) {
        const breadcrumbs: IBreadcrumbItem[] = [];
        const uniqueBreadcrumbsNames: string[] = [];
        while (route.firstChild) {
            route = route.firstChild;
            const breadcrumb = route.snapshot.data[breadcrumbDataKey];
            if (breadcrumb) {
                if (uniqueBreadcrumbsNames.includes(breadcrumb)) {
                    continue;
                }
                uniqueBreadcrumbsNames.push(breadcrumb);
                breadcrumbs.push({
                    name: typeof breadcrumb === 'string' ? signal(breadcrumb) : breadcrumb,
                    href: route.pathFromRoot.map(r => r.snapshot.url.map(segment => segment.path).join('/')).join('/'),
                });
            }
        }
        return breadcrumbs;
    }

    private setBreadcrumbs(breadcrumbs: IBreadcrumbItem[]) {
        this._breadcrumbs.next(breadcrumbs);
    }
}
